var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c(
      "div",
      { staticClass: "itemposter" },
      [
        _c(
          "mt-swipe",
          { attrs: { auto: 3000 } },
          _vm._l(_vm.details, function(item, idx) {
            return _c("mt-swipe-item", { key: idx }, [
              _c("img", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: { src: item.thumbUrl }
              })
            ])
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "rules" }, [
      _c("p", { staticClass: "rules_tit" }, [_vm._v("————活动规则————")]),
      _vm._v(" "),
      _c("p", { staticClass: "rule_content" }, [_vm._v(_vm._s(_vm.content))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad858b0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad858b0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/posterdetail/index.vue
// module id = null
// module chunks = 